import React from "react";
import CrudPage from "@/components/CrudPage";
import { Badge } from "@/components/Common";
import { PRIORITA, STATO_TASK, fmtDate } from "@/lib/constants";

export default function Attivita() {
  return (
    <CrudPage
      title="Attività & Task"
      subtitle="Assegnazioni, priorità, scadenze e stati"
      endpoint="attivita"
      testid="attivita-page"
      allegati
      columns={[
        { key: "titolo", label: "Titolo", render: (r) => <span className="font-medium text-slate-900">{r.titolo}</span> },
        { key: "assegnatario", label: "Assegnatario" },
        { key: "priorita", label: "Priorità", render: (r) => {
          const p = PRIORITA[r.priorita] || PRIORITA.normale;
          return <Badge label={p.label} cls={p.cls + " border-transparent"} />;
        } },
        { key: "scadenza", label: "Scadenza", render: (r) => {
          const late = r.scadenza && new Date(r.scadenza) < new Date() && r.stato !== "completata";
          return <span className={late ? "font-semibold text-rose-600" : ""}>{fmtDate(r.scadenza)}</span>;
        } },
        { key: "stato", label: "Stato", render: (r) => STATO_TASK[r.stato] || r.stato },
      ]}
      fields={[
        { name: "titolo", label: "Titolo", type: "text", full: true },
        { name: "assegnatario", label: "Assegnatario", type: "text" },
        { name: "priorita", label: "Priorità", type: "select",
          options: [{ value: "bassa", label: "Bassa" }, { value: "normale", label: "Normale" }, { value: "alta", label: "Alta" }, { value: "urgente", label: "Urgente" }] },
        { name: "scadenza", label: "Scadenza", type: "date" },
        { name: "stato", label: "Stato", type: "select",
          options: [{ value: "da_fare", label: "Da fare" }, { value: "in_corso", label: "In corso" }, { value: "in_revisione", label: "In revisione" }, { value: "completata", label: "Completata" }, { value: "annullata", label: "Annullata" }] },
        { name: "corso_id", label: "Corso collegato", type: "relation",
          relationEndpoint: "corsi", relationLabel: (o) => `${o.codice} — ${o.titolo}`, full: true },
      ]}
    />
  );
}
